export default __webpack_public_path__ + "static/media/russian poker-06.4ae9882d.png";